export const PRICE_ROUNDING_FACTOR = 10000
export const PRICE_ROUNDING_FACTOR_RATE = PRICE_ROUNDING_FACTOR * 100

export const multiplyByFactor = (value: number | string): number => {
  if (typeof value === 'string') {
    value = Number(value)
  }
  return Math.round(value * PRICE_ROUNDING_FACTOR)
}

export const multiplyByFactorRate = (value: number): number =>
  Math.round(value * PRICE_ROUNDING_FACTOR_RATE)

export const divideByFactor = (value: number): number =>
  value / PRICE_ROUNDING_FACTOR
export const divideByFactorRate = (value: number): number =>
  value / PRICE_ROUNDING_FACTOR_RATE

export const CLIENT_PROPOSAL_SERVICE_PROVIDER_OWNER_FEES_RATE =
  multiplyByFactor(15)
